import { render, staticRenderFns } from "./subjectQuickCopy.vue?vue&type=template&id=497ac464&"
import script from "./subjectQuickCopy.vue?vue&type=script&lang=js&"
export * from "./subjectQuickCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports